import React from "react";
import {getRatioProgressMeta, ProgressBadge} from "../../../../components/table/movable/renderer/ProgressStatusHandleBtn";

function resolveProgressCounts(data) {
    if (Array.isArray(data)) {
        return {done: data[0], total: data[1]};
    }
    if (data && typeof data === "object") {
        return {
            done: data.done ?? data.completed ?? data[0],
            total: data.total ?? data.count ?? data[1],
        };
    }
    return null;
}

function inspectionHeaderProgressRenderer({data}) {
    const counts = resolveProgressCounts(data);
    if (!counts) return null;

    const {label, percent, palette} = getRatioProgressMeta(counts.done, counts.total);

    return (
        <div className="flex min-w-0 w-full items-center py-0">
            <ProgressBadge label={label} percent={percent} palette={palette} />
        </div>
    );
}

export {inspectionHeaderProgressRenderer};
